import { Col } from 'react-bootstrap'
import styled from 'styled-components';
import { FaInfoCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useEdit } from '../../../hooks/useEdit';

const AlertContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 6px;
  margin: 4px 0px;
  background-color: #e6f4fb;
  border: 1px solid #4aa3d9;
  border-radius: 8px;
  color: #1a6fa0;
`;

const IconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2b8fd4;
  font-size: 20px;
  line-height: 1;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Title = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #1a6fa0;
  line-height: 1.3;
`;

const Description = styled.p`
  margin: 0;
  font-size: 10.5px;
  font-weight: 400;
  color: #2a7ab0;
  line-height: 1.30;
`;

const Warning = ({
  field
}) => {
  const { t } = useTranslation()
  const { colSize } = useEdit(field)

  if (field?.unique_name?.includes('user_additional_data__desired_amount_warning')) {
    return (
      <Col
        className={colSize}
      >
        <InfoAlert
          title={t('loanApplication.desiredLoanAmount.infoTitle')}
          description={t('loanApplication.desiredLoanAmount.infoDescription')}
          id={'desired_amount_warning'}
          name={field?.unique_name}
        />
      </Col>
    )
  }
  return null
}

export const InfoAlert = ({
  title,
  description,
  id,
  name
}) => {
  return (
    <AlertContainer 
      id={id}
      data-unique-name={ name }
    >
      <IconWrapper>
        <FaInfoCircle />
      </IconWrapper>
      <Content>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </Content>
    </AlertContainer>
  );
};

export default Warning